export const emptyStore = {
    name: "empty",
    reducers: {},
};
